import { toast } from "react-toastify";

import formErrorsHandler from "api/global/form-errors-handler";
import {
    companyInfoGet,
    companyInfoUpdateById,
} from "api/menu/master-files/company-info/requests";

export const FETCH_COMPANY_INFO_SUCCESS = "FETCH_COMPANY_INFO_SUCCESS";
export const FETCH_COMPANY_INFO_REQUEST_LOADING = "FETCH_COMPANY_INFO_REQUEST_LOADING";

export const setLoading = (status) => ({
    type: FETCH_COMPANY_INFO_REQUEST_LOADING,
    payload: status
});

export const fetchCompanyInfo = (reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_COMPANY_INFO_SUCCESS,
            payload: {}
        });
        return;
    }
    dispatch(setLoading(true));
    companyInfoGet()
        .then(response => {
            dispatch({
                type: FETCH_COMPANY_INFO_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateCompanyInfoById = (id, data) => dispatch => {
    dispatch(setLoading(true));
    companyInfoUpdateById(id, data)
        .then(() => {
            toast("Company info has been updated", {
                type: toast.TYPE.SUCCESS,
            });
            dispatch(setLoading(false));
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};
